import { hasAllKeys } from "../../lib/functional";
import {
  ControlInstance
} from "../instance";
class ListControl extends ControlInstance {
  constructor(definition, sendMessage) {
    super(sendMessage);
    this.definition = definition;
  }
  static ITEM_CONTROL_MESSAGE = "makeswift::controls::list::message::item-control-message";
  itemControls = /* @__PURE__ */ new Map();
  recv = (message) => {
    switch (message.type) {
      case ListControl.ITEM_CONTROL_MESSAGE: {
        this.child(message.payload.itemId)?.recv(message.payload.message);
      }
    }
  };
  child = (key) => this.itemControls.get(key);
  childControls = (ids) => {
    if (ids == null || hasAllKeys(this.itemControls, ids)) {
      return this.itemControls;
    }
    return new Map(
      ids.map((id) => [id, this.child(id) ?? this.createItemControl(id)])
    );
  };
  setChildControls = (children) => {
    this.itemControls = children;
  };
  createItemControl = (id) => {
    return this.definition.itemDef.createInstance(
      (message) => this.sendMessage({
        type: ListControl.ITEM_CONTROL_MESSAGE,
        payload: { message, itemId: id }
      })
    );
  };
}
export {
  ListControl
};
//# sourceMappingURL=list-control.js.map